var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94893 1.40177L9.90308 3.8843C9.89653 4.22491 10.1127 4.67687 10.3878 4.87993L12.0122 6.11134C13.0537 6.89736 12.8834 7.86024 11.6389 8.25325L9.52316 8.91482C9.16945 9.02618 8.79609 9.41264 8.70439 9.7729L8.20002 11.6987C7.80046 13.2183 6.80483 13.369 5.97951 12.0327L4.82665 10.1659C4.61704 9.8253 4.11923 9.56984 3.72622 9.58949L1.53845 9.70085C-0.0270471 9.77945 -0.472461 8.87552 0.54937 7.68339L1.84631 6.17684C2.08867 5.89518 2.20002 5.37117 2.08867 5.01748L1.42055 2.89522C1.03409 1.65068 1.72841 0.962908 2.96639 1.36902L4.8987 2.00439C5.22623 2.10919 5.7175 2.03714 5.99261 1.83408L8.01007 0.37994C9.10395 -0.399533 9.97513 0.0589805 9.94893 1.40177Z",
    fill: "#FF893F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6672 12.0979L10.6825 10.1132C10.4925 9.92321 10.1781 9.92321 9.98817 10.1132C9.79821 10.3031 9.79821 10.6175 9.98817 10.8075L11.9729 12.7922C12.0711 12.8905 12.1956 12.9363 12.32 12.9363C12.4445 12.9363 12.5689 12.8905 12.6672 12.7922C12.8572 12.6022 12.8572 12.2878 12.6672 12.0979Z",
    fill: "#FF893F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.e4e9d8110ad956328e22f2176c8cee99.svg";
export { ForwardRef as ReactComponent };